const navigation_anchors = document.querySelectorAll(
  ".content-text .field--name-field-text h2"
);

navigation_anchors.forEach((h2) => {
  h2.classList.add("navigation-anchor");
  h2.id = `anchor-${h2.innerText.toLowerCase().replace(/ /g, "-")}`;
});

function buildNavigation($sourceTitlesNodeList, $destinationElement) {
  let count_index = 0;
  $sourceTitlesNodeList.forEach((element) => {
    const ANCHOR = element.id;
    let TITLE = element.innerText;

    if (ANCHOR && TITLE) {
      const LIST_ITEM = document.createElement("li");
      LIST_ITEM.classList.add(ANCHOR, "content-navigation__item");
      if (document.body.classList.contains("language--nb")) {
        LIST_ITEM.innerHTML = `
        <span class="content-navigation__count">Del ${count_index + 1}</span>
        <a href="#${ANCHOR}" class="content-navigation__link">${TITLE}</a>
        `;
        $destinationElement.appendChild(LIST_ITEM);
        count_index++;
      } else {
        LIST_ITEM.innerHTML = `
        <span class="content-navigation__count">Part ${count_index + 1}</span>
        <a href="#${ANCHOR}" class="content-navigation__link">${TITLE}</a>
        `;
        $destinationElement.appendChild(LIST_ITEM);
        count_index++;
      }
    }
  });

  if (!$destinationElement.hasChildNodes()) {
    $destinationElement.remove();
  }

  return $destinationElement;
}

// if article.node has class 'node--forskning'
if (document.querySelector(".node--forskning")) {
  buildNavigation(
    document.querySelectorAll(".content-text .field--name-field-text h2"),
    document.querySelector("ul.content-navigation__list")
  );
}

new ClipboardJS("#copy-refer-article");

if (document.querySelector("#copy-refer-article")) {
  document
    .querySelector("#copy-refer-article")
    .addEventListener("click", () => {
      if (document.body.classList.contains("language--nb")) {
        document.querySelector("#copy-refer-article").innerHTML = "Kopiert!";
      } else {
        document.querySelector("#copy-refer-article").innerHTML = "Copied!";
      }
      setTimeout(() => {
        if (document.body.classList.contains("language--nb")) {
          document.querySelector("#copy-refer-article").innerHTML = "Kopier";
        } else {
          document.querySelector("#copy-refer-article").innerHTML = "Copy";
        }
      }, 1000);
    });
}
